/** Keep production navigation on the domain the customer chose. Only explicit
 * production hosts may select a domain; previews keep the configured fallback.
 */
export function publicEndpoints(hostname: string, websiteOverride?: string) {
  switch (hostname) {
    case 'console.roten-ai.com':
      return { websiteUrl: 'https://roten-ai.com', apiBaseUrl: 'https://api.roten-ai.com/v1' };
    case 'console.roten.ir':
      return { websiteUrl: 'https://roten.ir', apiBaseUrl: 'https://api.roten.ir/v1' };
    default:
      return {
        websiteUrl: (websiteOverride || 'https://roten.ir').replace(/\/$/, ''),
        apiBaseUrl: 'https://api.roten.ir/v1',
      };
  }
}

const endpoints = publicEndpoints(typeof window === 'undefined' ? '' : window.location.hostname, import.meta.env?.VITE_PUBLIC_WEBSITE_URL);
export const publicWebsiteUrl = endpoints.websiteUrl;
export const publicApiBaseUrl = endpoints.apiBaseUrl;
export const consoleBasePath = import.meta.env?.BASE_URL || '/';
